import { ref } from 'vue';

export function useDocumentValidity(props: {
  hasValidity: string;
  validityDate: Date | null;
  notificationDates: Date[];
}) {
  const hasValidity = ref(props.hasValidity);
  const validityDate = ref(props.validityDate);
  const notificationDates = ref([...props.notificationDates]);
  const isNotificationDatePickerOpen = ref(false);
  const isValidityDatePickerOpen = ref(false);
  const selectedDateForNotification = ref<Date | null>(null);
  const selectedDateForValidity = ref<Date | null>(null);

  const openValidityDatePicker = () => {
    isValidityDatePickerOpen.value = true;
  };

  const updateNotificationDates = (newDates: Date[]) => {
    notificationDates.value = newDates;
  };

  const openNotificationDatePicker = () => {
    selectedDateForNotification.value = null;
    isNotificationDatePickerOpen.value = true;
  };

  const onNotificationDateSelected = (date: Date | null) => {
    if (date) {
      if (!notificationDates.value.includes(date)) {
        notificationDates.value = [...notificationDates.value, date];
      }
    }
    isNotificationDatePickerOpen.value = false;
    selectedDateForNotification.value = null;
  };

  const onValidityDateSelected = (date: Date | null) => {
    if (date) {
      validityDate.value = date;
    }
    isValidityDatePickerOpen.value = false;
    selectedDateForValidity.value = null;
  };

  return {
    hasValidity,
    validityDate,
    notificationDates,
    isNotificationDatePickerOpen,
    isValidityDatePickerOpen,
    selectedDateForNotification,
    selectedDateForValidity,
    openValidityDatePicker,
    updateNotificationDates,
    openNotificationDatePicker,
    onNotificationDateSelected,
    onValidityDateSelected,
  };
}
